<template>
	<div class="login-container">
    <div class="logo" @click="toIndex">
      <img src="@/assets/logo.png" style="
                                width: 40px;
                                height: 40px;
                                margin: 5px 5px -5px 0;
                                -webkit-user-drag: none;
                                -khtml-user-drag: none;
                                -moz-user-drag: none;
                                user-drag: none;
                            " />
      <b style="color: white;display: inline-block; margin-bottom: 20px;font-size: 28px;">
        西安伟思特
      </b>
    </div>
		<el-card class="box-card">
			<div class="login-body">
				<div class="login-title" @click="toIndex">
					<b style="color: white;display: inline-block; margin-bottom: 20px;font-size: 28px;">
						管理员登录
					</b>
				</div>
        <b style="color: white">登录你的账户</b>
				<el-form ref="form" :model="userForm">
          <br>
					<el-input placeholder="请输入账号..." v-model="userForm.account" class="login-input">
						<template slot="prepend">
							<div class="iconfont icon-r-user2" style="font-size: 24px;"></div>
						</template>
					</el-input>
					<el-input placeholder="请输入密码..." v-model="userForm.password" class="login-input"
						@keyup.enter.native="login" show-password>
						<template slot="prepend">
							<div class="iconfont icon-r-lock" style="font-size: 24px;"></div>
						</template>
					</el-input>
					<div class="login-submit">
						<el-button type="primary" @click="login"> 登录</el-button>
					</div>
				</el-form>
			</div>
		</el-card>
    <b class="bottom-right-text">Copyright © 2024 西安伟思特声学科技</b>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				userForm: {
					account: '',
					password: ''
				}
			};
		},
		methods: {
			login() {
				this.$api.userLogin(this.userForm).then(res => {
					if (res.code == 200) {
						//提示
						this.$message({
							message: res.message,
							type: 'success'
						});
						//在浏览器中存储用用户账号信息
						sessionStorage.setItem("account", res.data.account);
						sessionStorage.setItem("id", res.data.id);
						sessionStorage.setItem("token", res.data.token)
            this.$api.getAdminInfo({id:res.data.id}).then(res => {
              if (res.code == 200) {
                sessionStorage.setItem("adminInfo", JSON.stringify(res.data));
                //路由跳转
                this.$router.push("/home");
              }
            })
					}
				});
			},
			toIndex() {
				this.$router.replace({
					path: '/index'
				});
			}
		}
	}
</script>

<style scoped>
	.box-card{
		background-color: #23233c;
	}

	.login-container {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		position: fixed;
		top: 0;
		left: 0;
		overflow-y: auto;
		height: 100%;
		background: #000028;
	}

	.login-body {
		padding: 30px;
		width: 300px;
		height: 100%;
    background-color: #23233c;
	}

	.login-title {
		padding-bottom: 30px;
		text-align: center;
		font-weight: 600;
		font-size: 20px;
		color: #409EFF;
		cursor: pointer;
	}

	.login-input {
		margin-bottom: 20px;
	}

	.login-submit {
		margin-top: 20px;
		display: flex;
		justify-content: center;
	}

	.sign-in-container {
		padding: 0 10px;
	}

	.sign-in-text {
		color: #409EFF;
		font-size: 16px;
		text-decoration: none;
		line-height: 28px;
	}

	.other-submit {
		display: flex;
		justify-content: space-between;
		margin-top: 30px;
		margin-left: 200px;
	}

  .logo {
    /* 绝对定位，相对于 .login-container */
    position: absolute;
    top: 20px;
    left: 20px;
    padding-bottom: 0;
    margin: 0;
    /* 颜色 */
    color: #fff;
  }

  .bottom-right-text {
    position: absolute; /* 绝对定位 */
    right: 20px; /* 距离右侧 20px */
    bottom: 20px; /* 距离底部 20px */
    color: white; /* 文本颜色 */
  }

</style>